module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Broom-562446d41acad2a67518b0657f1c8c4804f5f5f1e05a662e0cd8bf278843d2d0.svg";